import type { User } from "../services/UserService";

const normalizeRetailerRoot = (value: string): string => {
  const normalized = value.replace(/-/g, "_");
  if (normalized.includes("home_depot")) return "home_depot";
  if (normalized.includes("walmart_online")) return "walmart_online";
  if (normalized.includes("dollar_general")) return "dollar_general";
  if (normalized.includes("bestbuy")) return "bestbuy";
  if (normalized.includes("woot")) return "woot";
  if (normalized.includes("target")) return "target";
  if (normalized.includes("walmart")) return "walmart";
  return normalized;
};

export const hasAnyActiveRetailerPlan = (user: User | null): boolean =>
  !!user?.retailers?.length;

export const getDuplicateRetailers = (
  user: User | null,
  selectedRetailers: string[]
): string[] => {
  if (!user?.retailers?.length) return [];
  const existing = new Set(
    user.retailers.map((retailer) => normalizeRetailerRoot(retailer))
  );
  return selectedRetailers
    .map((retailer) => normalizeRetailerRoot(retailer))
    .filter((retailer) => existing.has(retailer));
};
